import React, { Dispatch, SetStateAction, useEffect, useMemo } from 'react';

import cn from 'classnames';
import { useRouter } from 'next/router';
import { Tab } from 'src/pages/airdrop/history';

// import { helper } from '@utils/index';
// import { usePrecision } from '@widget/airdrop/hooks/usePrecision';
import type { AirdropClaimRecordType, AirdropSendRecordType } from '@api/index';
import { AIRDROP_PATHS } from '@constants/index';
import { TabPane, Tabs } from '@element/index';
import useClient from '@lib/hooks/useClient';
import { I18n } from '@utils/index';

import styles from './index.module.less';

interface HistoryTabsProps {
  setTab: Dispatch<SetStateAction<Tab>>;
  historyData: AirdropClaimRecordType | AirdropSendRecordType;
  tab: Tab;
}

export const HistoryTabs: React.FC<HistoryTabsProps> = (props) => {
  const { setTab, historyData, tab } = props;
  const isPc = useClient();
  const router = useRouter()
  useEffect(() => {
    if (router.isReady && router.query.activeKey) {
      // 返回到历史页面是，定位到对应tab
      setTab(router.query.activeKey as Tab);
    }
  }, [router, setTab])

  const numText = useMemo(() => {
    const textMap = {
      claim: I18n.t('NgPOi1dE', { num: historyData?.num || 0 }),
      send: I18n.t('6prYWtqn', { num: historyData?.num || 0 })
    };
    return textMap[tab];
  }, [tab, historyData]);

  return (
    <div className={styles.container}>
      <div>
        <Tabs
        activeKey={tab}
          type="primary"
          className={styles.tab}
          tabBarGutter={isPc ? 64 : 32}
          onChange={(activeKey) => {
            setTab(activeKey as Tab);
            router.replace({
              pathname: AIRDROP_PATHS.HISTORY,
              query: {
                activeKey
              }
            })
          }}
        >
          <TabPane
            tab={<h2 className={styles.panel}>{I18n.t('x9LIktj0')}</h2>}
            key="claim"
            type="primary"
          />
          <TabPane
            tab={<h2 className={styles.panel}>{I18n.t('PQlQZ2kZ')}</h2>}
            key="send"
            type="primary"
          />
        </Tabs>
      </div>
      <div className={styles.info}>
        <span className={styles.airdropNum}>{numText}</span>
        <div className={cn(styles.coinNum, 'DINPro-Medium')}>
          {/* {`≈ ${helper.formatFixNumString(
            historyData?.amount,
            usePrecision({ coinCode: 'USDC' })
          )} USDC`} */}
          {`≈ ${historyData?.amount || 0} USD`}
        </div>
      </div>
    </div>
  );
};
